import { render, staticRenderFns } from "./liveclass.vue?vue&type=template&id=4f34fe62&scoped=true&"
import script from "./liveclass.vue?vue&type=script&lang=js&"
export * from "./liveclass.vue?vue&type=script&lang=js&"
import style0 from "./liveclass.vue?vue&type=style&index=0&id=4f34fe62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f34fe62",
  null
  
)

export default component.exports